@if (content?.categoryQuicklinks) {
<div class="wrap-s center _category-quicklinks">
    <div class="w-12 pos-relative m-t-3 m-b-3">
        <carousel class="swiper-overflow-visible"
                  [slidesPerView]="'auto'"
                  [spaceBetween]="8">
            @for (quicklink of content?.categoryQuicklinks; track quicklink) {
            <ng-template swiperSlide>
                <div class="inline-block no-wrap m-l-1 m-r-2">
                    <href [link]="quicklink.link"
                          [hrefCurrentClass]="'is-active'">
                        <p class="p2"
                           *iCms="'text' of quicklink"></p>
                    </href>
                </div>
            </ng-template>
            }
        </carousel>
    </div>
</div>
}
